import React from 'react';
import { FiAlertCircle, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useImportErrorsBanner } from './use-import-errors-banner';
import styles from '../styles.module.scss';

/*
 * Banner listing broken DAG files and their tracebacks, mirroring Airflow's own
 * "DAG Import Errors" panel shown above the DAGs list
 */
export function ImportErrorsBanner() {
    const { importErrors, isExpanded, handleToggleExpanded } = useImportErrorsBanner();

    if (importErrors.length === 0) return null;

    return (
        <div className={styles.importErrorsBanner}>
            <div className={styles.importErrorsHeader} onClick={handleToggleExpanded}>
                <span className={styles.importErrorsTitle}>
                    <FiAlertCircle /> DAG Import Errors ({importErrors.length})
                </span>
                {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
            </div>
            {isExpanded && (
                <div className={styles.importErrorsBody}>
                    {importErrors.map((error) => (
                        <div key={error.import_error_id} className={styles.importErrorItem}>
                            <div className={styles.importErrorFilename}>Broken DAG: [{error.filename}]</div>
                            <pre className={styles.importErrorTrace}>{error.stack_trace}</pre>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
